module.exports = __webpack_public_path__ + "img/box4.9af763d3.png";